<template>
  <div class="container-custom">
    <!-- breadscrumbs -->
    <div class="breadscrumbs">
      <a class="breadscrumbs-item active">Navigation</a>
    </div>
    <!-- page actions -->
    <div class="page-actions">
      <h2>Navigation</h2>
      <v-spacer></v-spacer>
      <button class="btn" @click="toNavigationEdit">
        <v-icon class="mr-2">edit</v-icon>
        <span class="mr-2">編輯</span>
      </button>
    </div>
    <!-- block 1 -->
    <div class="block" style="height: 70vh; margin-bottom: 30px;">
      <PageMenu :sections="sections">
        <component :is="sectionView" :navigation="navigation"></component>
      </PageMenu>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import HeaderNav from '@/views/B-2__Navigation/c/B-2-1a__Navigation_Header-Nav.vue';
import SubNav from '@/views/B-2__Navigation/c/B-2-1b__Navigation_Sub-Nav.vue';
import FooterMenu from '@/views/B-2__Navigation/c/B-2-1c__Navigation_Footer-Menu.vue';
import FooterDisclaimer from '@/views/B-2__Navigation/c/B-2-1d.vue';
import SocialMedia from '@/views/B-2__Navigation/c/B-2-1e.vue';
import PageMenu from '@/components/PageMenu.vue';

export default {
  components: {
    HeaderNav,
    SubNav,
    FooterMenu,
    FooterDisclaimer,
    SocialMedia,
    PageMenu,
  },
  data: () => ({
    sections: [
      {
        name: 'Header-Nav',
        component: 'HeaderNav',
      },
      {
        name: 'Sub-Nav',
        component: 'SubNav',
      },
      {
        name: 'Footer Menu',
        component: 'FooterMenu',
      },
      {
        name: 'Footer Disclaimer',
        component: 'FooterDisclaimer',
      },
      {
        name: 'Social Media',
        component: 'SocialMedia',
      },
    ],
  }),
  computed: {
    ...mapState('navigation', ['navigation']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  async created() {
    this.clear();
    await this.getNavigations();
  },
  methods: {
    ...mapActions('navigation', {
      getNavigations: 'find',
      clear: 'clear',
    }),
    toNavigationEdit() {
      this.$router.push({
        name: 'NavigationEdit',
        query: {
          section: this.$route.query.section,
        },
      });
    },
  },
};
</script>

<style></style>
